import { useModelService } from "@shared/services/api/hooks/useModelService";
import PublicBasedRefundProtectionConfigurationRepository from "../../repositories/PublicBasedRefundProtectionConfigurationRepository";

const repository = new PublicBasedRefundProtectionConfigurationRepository();
const usePublicBasedRefundProtectionConfigurationService = () => {
  const { useRetrieve } = useModelService(repository);

  const useRetrieveVenueConfiguration = (venueId?: number) => {
    return useRetrieve(venueId, {
      config: {
        url: repository.buildUrl("config"),
        params: {
          venue_id: venueId,
        },
        showToastOnError: false,
      },
      options: {
        enabled: Boolean(venueId),
      },
    });
  };

  return {
    useRetrieveVenueConfiguration,
  };
};

export default usePublicBasedRefundProtectionConfigurationService;
